module.exports = __webpack_public_path__ + "static/media/Lato-Regular.c5eb5440.ttf";